import _ from 'lodash';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import FormText from "../form/FormText";

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import CircularProgress from '@material-ui/core/CircularProgress';
import Zoom from '@material-ui/core/Zoom';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import Grid from "@material-ui/core/Grid";
import TmwApi from '../../containers/Ticket/TmwApi';
import {gridMargin} from "../form/general";


const styles = () => {
	return {
		fetching : {
			fontStyle : 'italic',
			padding : '10px 0px',
			color : '#777',
		},
		successCheck : {
			width : 40,
			height : 40,
			color : green[500]
		},
		errorIcon : {
			width : 40,
			height : 40,
			color : red[500]
		},
		progress : {
			width : 40,
			height : 40,
		},
		statusContainer : {
			position : 'relative',
			width : 50,
			height: 40,
			paddingLeft: 10,
		},
		statusPosition : {
			position : 'absolute'
		},
		arrowLeft : {
			paddingTop : 5,
			width : 40,
			height : 40,
			color : '#bbb',
			transform: 'scaleX(-1)',
		}
	};
};

class TmwOrderId extends PureComponent {
	state = {
		status : 'idle',
		error : undefined,
	};
	recordSets;

	//- Called from the select
	onChange = (value, path) => {
		const {onChange, onTmwInfoUpdate, searchTmw } = this.props;

		//- Call the parent onChange so the value is stored immediately
		//- later we might call a different method
		onChange(value, path);

		if (!value || value.length < 7) {
			this.setState({ status : 'idle' });
			return;
		}

		this.setState({ status : 'isFetching' });

		setTimeout(() => {

			searchTmw({
				params : {
					tmwOrderId : value
				},
				callback : (err, result) => {
					if (err) {
						this.setState({ error : err, status : 'error' });
						return;
					}

					this.setState({ status : 'successfulFetch' });

					if (!result) {
						this.setState({ error : 'No result returned', status : 'error' });
					}

					if (_.isEmpty(result.recordSets)) {
						this.setState({ error : 'TMW Order Id did not return any results', status : 'error' });
					}

					const tmwData = _.first(result.recordSets);
					onTmwInfoUpdate({ tmwData });
				}
			});
		}, 200);
	};

	render () {
		const { classes, gridProps } = this.props;
		const { status } = this.state;

		const content = (
			<div style={{display : 'flex', alignItems : 'center' }}>
				<FormText
					{...this.props}
					onChange={this.onChange}
					gridProps={undefined}
				/>

				<div className={classes.statusContainer}>

					<div className={classes.statusPosition}>
						{status === 'idle' &&
						<ArrowRightAltIcon className={classes.arrowLeft} />
						}
					</div>

					<div className={classes.statusPosition}>
						{status === 'isFetching' &&
						<CircularProgress className={classes.progress} />
						}
					</div>
					<div className={classes.statusPosition}>
						<Zoom in={status === 'successfulFetch'}>
							<CheckCircleIcon className={classes.successCheck} />
						</Zoom>
					</div>

					<div className={classes.statusPosition}>
						<Zoom in={status === 'error'}>
							<ErrorIcon className={classes.errorIcon} />
						</Zoom>
					</div>
				</div>
			</div>
		);

		if (gridProps) {
			_.defaults(gridProps, { xs : 12 });
			return (<Grid item {...gridProps} style={gridMargin}>{content}</Grid>);
		} else {
			return content;
		}
	}
}

TmwOrderId.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.string,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	onTmwInfoUpdate : PropTypes.func.isRequired,
	error : PropTypes.string,
	classes : PropTypes.object,
	helpText : PropTypes.string,
	gridProps : PropTypes.object,
	searchTmw : PropTypes.func.isRequired,
};

TmwOrderId.defaultProps =  {
	label : 'Ticket Category',
};

export default _.flow([
	withStyles(styles),
	TmwApi,
])(TmwOrderId);